import React from "react"
import LoginPage from "@pages/login"

function App() {
  return <LoginPage />
}

export default App
